/* ============================================================================
   GH Locations — interactive controller.
   - Click a location card → highlight, swap the desktop map iframe src,
     swap the mobile map iframe src (placed under the active card),
     update map header (name + external link).
   - Defers iframe loads until selected, keeping initial paint cheap.
   - Stateless, no dependencies.
   ============================================================================ */
(function () {
  function init(root) {
    if (!root || root.__ghLocInit) return;
    root.__ghLocInit = true;

    var cards = Array.prototype.slice.call(root.querySelectorAll('.gh-locations__card'));
    if (!cards.length) return;

    var desktopFrame  = root.querySelector('[data-gh-loc-map="desktop"]');
    var mobileFrameWrap = root.querySelector('[data-gh-loc-mobile-map]');
    var nameEl  = root.querySelector('[data-gh-loc-name]');
    var extLink = root.querySelector('[data-gh-loc-external]');

    function select(card, opts) {
      opts = opts || {};
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var embed = card.getAttribute('data-embed') || '';
      var ext   = card.getAttribute('data-external') || '';
      var name  = card.getAttribute('data-name') || '';

      if (desktopFrame && embed) {
        // Only update src when it actually changes to avoid a needless reload.
        if (desktopFrame.getAttribute('src') !== embed) {
          desktopFrame.setAttribute('src', embed);
        }
      }
      if (nameEl)  nameEl.textContent = name;
      if (extLink && ext) extLink.setAttribute('href', ext);

      // Mobile map: move the iframe under the currently-active card.
      if (mobileFrameWrap && embed) {
        var existingIframe = mobileFrameWrap.querySelector('iframe');
        if (!existingIframe) {
          existingIframe = document.createElement('iframe');
          existingIframe.setAttribute('loading', 'lazy');
          existingIframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
          existingIframe.setAttribute('allowfullscreen', '');
          existingIframe.setAttribute('title', 'Map');
          mobileFrameWrap.appendChild(existingIframe);
        }
        if (existingIframe.getAttribute('src') !== embed) {
          existingIframe.setAttribute('src', embed);
        }
        existingIframe.setAttribute('title', name ? ('Map — ' + name) : 'Map');

        // Move the wrapper to sit directly after the active card on mobile only.
        if (window.matchMedia('(max-width: 899px)').matches) {
          if (card.nextElementSibling !== mobileFrameWrap) {
            card.parentNode.insertBefore(mobileFrameWrap, card.nextElementSibling);
          }
          if (opts.scroll) {
            // Smoothly bring the map into view on mobile selection
            try {
              mobileFrameWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            } catch (e) {
              mobileFrameWrap.scrollIntoView();
            }
          }
        }
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        // Don't hijack clicks on inner buttons/links
        var t = e.target;
        if (t.closest && t.closest('a, button:not(.gh-locations__card)')) return;
        select(card, { scroll: true });
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          var t = e.target;
          if (t !== card) return;
          e.preventDefault();
          select(card, { scroll: true });
        }
      });
    });

    // On resize between mobile/desktop, re-place the mobile map wrapper correctly.
    var mql = window.matchMedia('(max-width: 899px)');
    var onChange = function () {
      var active = root.querySelector('.gh-locations__card.is-active') || cards[0];
      if (active) select(active, { scroll: false });
    };
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else if (mql.addListener) mql.addListener(onChange);

    // Initial selection
    var initial = root.querySelector('.gh-locations__card.is-active') || cards[0];
    if (initial) select(initial, { scroll: false });
  }

  function boot() {
    document.querySelectorAll('[data-gh-locations]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when the section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-gh-locations]');
    if (root) init(root);
  });
})();
